<template>
  <!--    Alert Form-->
  <validation-observer
      ref="alertForm"
      v-slot="{invalid}"
  >
    <lenon-modal
        :title="`${updateAlertMode?'Update':'Create'} Alert`"
        :show="alertModalOpened"
        :show-overlay="deletingAlert"
        size="md"
        @onClose="closeAlertModal()"
    >
      <b-row class="align-items-start">
        <div class="col-7">
          <lenon-select
              v-model="selectedAlertId"
              placeholder="All Alerts"
              :options="alerts"
              label-name="title"
              value-name="id"
              @input="populateAlertForm"
          />
        </div>
        <div class="col-2">
          <lenon-dropdown
              icon="TrashIcon"
          >
            <b-dropdown-item @click="deleteAlert()">
              Yes
            </b-dropdown-item>
            <b-dropdown-divider />
            <b-dropdown-item>
              No
            </b-dropdown-item>
          </lenon-dropdown>
        </div>
        <div class="col-2">
          <lenon-button
              variant="flat-danger"
              icon="XIcon"
              label=""
              tool-tip-text="Clear Form"
              @onClick="resetAlertForm()"
          />
        </div>
      </b-row>
      <error-display :error="error" />
      <lenon-input
          v-model="title"
          name="alert_type"
          placeholder="Enter alert type"
          rules="required"
          label="Alert Type"
      />
      <template slot="modal-actions">
        <b-row class="float-right">
          <lenon-button
              name="cancel"
              variant="flat-danger"
              icon="XIcon"
              class="mr-1"
              label="Cancel"
              @onClick="closeAlertModal()"
          />
          <lenon-button
              :label="updateAlertMode?'Update':'Create'"
              :disabled="invalid"
              :loading="alertLoading"
              loading-text="Loading..."
              @onClick="updateAlertMode?updateAlert():createAlert()"
          />
        </b-row>
      </template>
    </lenon-modal>
  </validation-observer>
</template>

<script>
import { BRow, BDropdownItem, BDropdownDivider } from 'bootstrap-vue'
import { ValidationObserver } from 'vee-validate'
import LenonModal from '@/lenon/components/LenonModal.vue'
import LenonInput from '@/lenon/components/LenonInput.vue'
import LenonButton from '@/lenon/components/LenonButton.vue'
import showToast from '@/lenon/mixins/showToast'
import LenonSelect from '@/lenon/components/LenonSelect.vue'
import { CREATE_ALERT_M, DELETE_ALERT_M, UPDATE_ALERT_M } from '@/graphql/mutations'
import LenonDropdown from '@/lenon/components/LenonDropdown.vue'
import ErrorDisplay from '@/lenon/components/ErrorDisplay'
import logData from '@/libs/log'

export default {
  name: 'AlertSetup',
  components: {
    ErrorDisplay,
    LenonDropdown,
    LenonSelect,
    LenonButton,
    LenonInput,
    LenonModal,
    ValidationObserver,
    BRow,
    BDropdownItem,
    BDropdownDivider,
  },
  mixins: [showToast],
  props: {
    modalOpened: { type: Boolean, default: false },
  },
  data() {
    return {
      error: {},
      alertModalOpened: false,
      updateAlertMode: false,
      alertLoading: false,
      deletingAlert: false,
      selectedAlertId: null,
      title: '',
    }
  },
  computed: {
    selectedAlert() {
      return this.alerts.find(ter => ter.id === this.selectedAlertId)
    },
    alerts() {
      return this.$store.getters['calendarEvents/alerts']
    },
  },
  watch: {
    modalOpened(opened) {
      this.alertModalOpened = opened
    },
  },
  methods: {
    // alert
    resetAlertForm() {
      this.title = ''
      this.selectedAlertId = null
      this.updateAlertMode = false
      this.$refs.alertForm.reset()
    },
    populateAlertForm(alert) {
      if (this.selectedAlert) {
        this.updateAlertMode = true
        this.title = this.selectedAlert?.title
      } else {
        this.resetAlertForm()
      }
    },
    closeAlertModal() {
      this.alertModalOpened = false
      this.$emit('modalClosed')
    },
    updateAlert() {
      this.error = {}
      if (!this.selectedAlertId) {
        return
      }
      this.alertLoading = true
      this.$apollo.mutate({
        mutation: UPDATE_ALERT_M,
        variables: { input: { id: this.selectedAlertId, title: this.title } },
      }).then(res => {
        this.showSuccess('Updated alert successfully')
        this.alertLoading = false
        this.$store.commit('calendarEvents/updateAlert', res.data.updateAlert)
      }).catch(err => {
        logData(err)
        this.error = err
        this.showError('Failed to update alert')
        this.alertLoading = false
      })
    },
    createAlert() {
      this.error = {}
      this.alertLoading = true
      this.$apollo.mutate({
        mutation: CREATE_ALERT_M,
        variables: { input: { title: this.title } },
      }).then(res => {
        this.showSuccess('Created alert successfully')
        this.alertLoading = false
        this.$store.commit('calendarEvents/addAlert', res.data.createAlert)
        this.resetAlertForm()
      }).catch(err => {
        logData(err)
        this.error = err
        this.alertLoading = false
        this.showError('Failed to create alert')
      })
    },
    deleteAlert() {
      if (!this.selectedAlertId) {
        this.showInfo('Please select a alert')
        return
      }
      this.deletingAlert = true
      this.$apollo.mutate({ mutation: DELETE_ALERT_M, variables: { id: this.selectedAlertId } }).then(() => {
        this.deletingAlert = false
        this.showSuccess('Deleted Successfully')
        this.$store.commit('calendarEvents/removeAlert', this.selectedAlertId)
        this.selectedAlertId = null
        this.resetAlertForm()
      }).catch(() => {
        this.showError('Failed to delete alert')
        this.deletingAlert = false
      })
    },

  },
}
</script>
